import * as React from 'react';
import { Controller, CustomArgs, Menu, Toolbar } from '@tencent/workbench';
import { VerticlaAlignFeature } from './verticla-align-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_V_ALIGN } from '@framework/workbench/drawer/ui/text/paragraph/config';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

/**
 * 工具栏 - 垂直对齐
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
    formItems: FORM_CONFIGS_V_ALIGN,
})
export class VerticlaAlignController {
    constructor(private readonly feature: VerticlaAlignFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public showContent() {
        return this.feature.showContent(true);
    }

    @Toolbar(config.id, 'icon')
    public getFontName() {
        const icon = this.feature.getSelectedIcon();
        return <img src={icon || config.icon} alt={''}/>;
    }

    @Menu(AlignType.VERTICAL_TOP, 'onClick', { vertical: AlignType.VERTICAL_TOP })
    @Menu(AlignType.VERTICAL_CENTER, 'onClick', { vertical: AlignType.VERTICAL_CENTER })
    @Menu(AlignType.VERTICAL_BOTTOM, 'onClick', { vertical: AlignType.VERTICAL_BOTTOM })
    public handleClick(@CustomArgs() args: { vertical: string }) {
        this.feature.callback(args.vertical);
    }

    @Menu(AlignType.VERTICAL_TOP, 'shouldCheck', { vertical: AlignType.VERTICAL_TOP })
    @Menu(AlignType.VERTICAL_CENTER, 'shouldCheck', { vertical: AlignType.VERTICAL_CENTER })
    @Menu(AlignType.VERTICAL_BOTTOM, 'shouldCheck', { vertical: AlignType.VERTICAL_BOTTOM })
    @Form(AlignType.VERTICAL_TOP, 'value', { vertical: AlignType.VERTICAL_TOP })
    @Form(AlignType.VERTICAL_CENTER, 'value', { vertical: AlignType.VERTICAL_CENTER })
    @Form(AlignType.VERTICAL_BOTTOM, 'value', { vertical: AlignType.VERTICAL_BOTTOM })
    public shouldCheck(@CustomArgs() args: { vertical: string }) {
        return this.feature.getItemValue() === args.vertical;
    }

    @Form(AlignType.VERTICAL_TOP, 'onClick', { vertical: AlignType.VERTICAL_TOP })
    @Form(AlignType.VERTICAL_CENTER, 'onClick', { vertical: AlignType.VERTICAL_CENTER })
    @Form(AlignType.VERTICAL_BOTTOM, 'onClick', { vertical: AlignType.VERTICAL_BOTTOM })
    public handleDrawerClick(@CustomArgs() args: { vertical: string }) {
        this.feature.drawerCallback(args.vertical);
    }
}
